import { InputLabel } from "@mui/material";
import React from "react";

function CustomInputLabel({ label }) {
  return (
    <InputLabel
      sx={{
        fontFamily: "Poppins",
        mb: 0,
        color: "#696F79",
        fontWeight: 500,
        fontSize: "13px",
      }}
    >
      {label}
    </InputLabel>
  );
}

export default CustomInputLabel;
